import APIService from '@/services/APIService.js';

const base = '/conciliacoes-v3';

export default {
  getAll(includeExpiredRecords = false) {
    return APIService.apiCall().get(`${base}/getAll/${includeExpiredRecords}`);
  },
  getEntity(id) {
    return APIService.apiCall().get(`${base}/getEntity/${id}`);
  },
  catalogoCriacao() {
    return APIService.apiCall().get(`${base}/catalogoCriacao`);
  },
  salvarInicio(postData, id = null) {
    const suffix = id ? `/${id}` : '';
    return APIService.apiCall().post(`${base}/salvarInicio${suffix}`, JSON.stringify(postData));
  },
  uploadPartida(id, formData) {
    return APIService.apiCall().post(`${base}/uploadPartida/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  uploadReferencia(id, formData) {
    return APIService.apiCall().post(`${base}/uploadReferencia/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  mapearPartida(id, postData) {
    return APIService.apiCall().post(`${base}/mapearPartida/${id}`, JSON.stringify(postData));
  },
  mapearReferencia(id, postData) {
    return APIService.apiCall().post(`${base}/mapearReferencia/${id}`, JSON.stringify(postData));
  },
  sugestaoMapeamento(id) {
    return APIService.apiCall().get(`${base}/sugestaoMapeamento/${id}`);
  },
  listarRodadas(id, params = {}) {
    return APIService.apiCall().get(`${base}/listarRodadas/${id}`, { params });
  },
  gerarRodadas(id, postData = {}) {
    return APIService.apiCall().post(`${base}/gerarRodadas/${id}`, JSON.stringify(postData));
  },
  salvarRodadas(id, postData) {
    return APIService.apiCall().post(`${base}/salvarRodadas/${id}`, JSON.stringify(postData));
  },
  excluirRodada(id, rodadaId) {
    return APIService.apiCall().post(`${base}/excluirRodada/${id}/${rodadaId}`, JSON.stringify({}));
  },
  executar(id) {
    return APIService.apiCall().post(`${base}/executar/${id}`, JSON.stringify({}));
  },
  progresso(id) {
    return APIService.apiCall().get(`${base}/progresso/${id}`);
  },
  metricasExecucao(id) {
    return APIService.apiCall().get(`${base}/metricasExecucao/${id}`);
  },
  andamento(id) {
    return APIService.apiCall().get(`${base}/andamento/${id}`);
  },
  baixar(id) {
    return APIService.apiCall().get(`${base}/baixar/${id}`);
  },
  baixarLog(id) {
    return APIService.apiCall().get(`${base}/baixarLog/${id}`, {
      responseType: 'blob',
      timeout: 60 * 60 * 1000
    });
  },
  profilingPartida(id) {
    return APIService.apiCall().get(`${base}/profilingPartida/${id}`);
  },
  profilingReferencia(id) {
    return APIService.apiCall().get(`${base}/profilingReferencia/${id}`);
  },
  excluir(id) {
    return APIService.apiCall().get(`${base}/excluir/${id}`);
  }
};
